import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Spacer } from '../../types';
import NewAlert from '../Alert/NewAlert';

type ErrorAlertProps = {
	onDismiss?: () => void;
	children?: JSX.Element[] | JSX.Element
};

export type ErrorProps = ErrorAlertProps & {
	error: string;
	notInContainer?: boolean;
	noBack?: boolean;
	p?: Spacer;
	px?: Spacer;
	py?: Spacer;
	pt?: Spacer;
	pr?: Spacer;
	pb?: Spacer;
	pl?: Spacer;
};

const Back = (
	<Link to="/" className="btn btn-outline-dark">
		Go back.
	</Link>
);

const ErrorAlert: React.FC<ErrorAlertProps > = ({
	onDismiss,
	children
}) => {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<NewAlert
			toggle={() => {
				setIsOpen(!isOpen);

				if (onDismiss) {
					onDismiss();
				}
			}}
		>
			{children}
		</NewAlert>
	);
};

export const Error: React.FC<ErrorProps> = ({
	error,
	noBack = false,
	notInContainer = false,
	onDismiss,
	p = 3,
	px = p,
	py = p,
	pt = py,
	pr = px,
	pb = py,
	pl = px
}) =>
	notInContainer ? (
		<div
			className={`error pt-${pt} pr-${pr} pb-${pb} pl-${pl}`}
			style={{ zIndex: 1000 }}
		>
			<div className="alert alert-danger">
				<p className={noBack ? 'mb-0' : ''}>{error}</p>

				{!noBack && Back}
			</div>
		</div>
	) : (
		<ErrorAlert onDismiss={onDismiss}>
			<p className={noBack ? 'mb-0' : ''}>{error}</p>

			{!noBack ? Back : <></>}
		</ErrorAlert>
	);
